import React from "react";
import { TESTIMONIALS, THIRD_PARTY } from "@/content/site";

export const Testimonials = () => {
  if (!TESTIMONIALS.length) return null;
  return (
    <section className="mt-16" data-testid="testimonials-section" aria-labelledby="testimonials-heading">
      <h2 id="testimonials-heading" className="font-display text-2xl font-medium text-[#F8F3E6]">From people who've drawn here</h2>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {TESTIMONIALS.map((t) => (
          <figure key={t.name} className="rounded-xl border border-[#D9A441]/15 bg-[#131422]/50 p-5">
            <blockquote className="text-sm leading-relaxed text-[#F8F3E6]">“{t.quote}”</blockquote>
            <figcaption className="mt-3 flex items-center gap-3 text-xs text-[#A3A5B8]">
              {t.photo && <img src={t.photo} alt={t.name} className="h-8 w-8 rounded-full object-cover" />}
              {t.name}{t.context ? ` · ${t.context}` : ""}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export const ThirdPartyStrip = () => {
  if (!THIRD_PARTY.length) return null;
  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-xs text-[#A3A5B8]" data-testid="third-party-strip">
      {THIRD_PARTY.map((m) => (
        <a key={m.label} href={m.url} target="_blank" rel="noopener noreferrer" className="hover:text-[#F8F3E6]">
          {m.label} — {m.source}, {m.date}
        </a>
      ))}
    </div>
  );
};
